#import "./AddressFull.graphql"
#import "./PaymentFull.graphql"
#import "./OrderPricesFull.graphql"
#import "./OrderProductFull.graphql"
#import "./FakturoidDataFull.graphql"
#import "./GoPayDataFull.graphql"

fragment PublicOrderFull on PublicOrder {
  b2cDetailId
  billingAddress {
    ...AddressFull
  }
  deliveryAddress {
    ...AddressFull
  }
  deliveryType
  modifiedAt
  orderNumber
  paidAt
  legacyOrderId
  fakturoidData {
    ...FakturoidDataFull
  }
  goPayData {
    ...GoPayDataFull
  }
  payment {
    ...PaymentFull
  }
  prices {
    ...OrderPricesFull
  }
  products {
    ...OrderProductFull
  }
  status
  createdAt
}
